var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["personal-stylist/style-options.j2"] = require( "personal-stylist/style-options.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["help/templates/personal-stylist/home-style.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12\">\n\n        <h2 class=\"c-personal-stylist__h2\" data-qa-home-style-heading>\n            ";
output += runtime.suppressValue((lineno = 5, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["personal-stylist_style"])), env.opts.autoescape);
output += "\n        </h2>\n\n    </div>\n\n</div>\n\n<div class=\"o-row o-column o-extra-small--12 o-large--8\">\n\n    <div class=\"o-column o-extra-small--12 o-large--8\">\n\n        <div class=\"c-form__field\">\n\n            <label for=\"color-preferences\" class=\"c-form__label\">\n                ";
output += runtime.suppressValue((lineno = 19, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["personal-stylist_color-preference-label"])), env.opts.autoescape);
output += "\n            </label>\n\n            <input\n                type=\"text\"\n                id=\"color-preferences\"\n                name=\"color_preferences\"\n                class=\"c-form__text\"\n                maxlength=\"255\"\n                data-qa-color-preferences\n            />\n\n        </div>\n\n    </div>\n\n</div>\n\n<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12\">\n\n        <p class=\"c-personal-stylist__p\" data-qa-home-copy>\n            ";
output += runtime.suppressValue((lineno = 42, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["personal-stylist_style-home-copy"])), env.opts.autoescape);
output += "\n        </p>\n\n    </div>\n\n</div>\n\n";
env.getTemplate("personal-stylist/style-options.j2", false, "help/templates/personal-stylist/home-style.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["help/templates/personal-stylist/home-style.j2"] , dependencies)